import { useMemo } from 'react';
import {
    RECOMMENDED_ACTION,
    DEFAULT_RECORDS_REVIEWED,
    DEFAULT_RECORDS_SUMMARY,
    FUTURE_CARE_SIGNAL,
    FALLBACK_CARE_CATEGORIES,
    ATTORNEY_NEXT_STEP,
    RECOMMENDED_ROUTES,
    PREVIEW_DISCLAIMER,
} from '../components/preliminary-lifecare/preliminaryPreviewContent';

const buildRecordsSummaryFromPlan = (plan) => ({
    title: plan?.summaryOfRecords?.title?.trim() || DEFAULT_RECORDS_SUMMARY.title,
    content: plan?.summaryOfRecords?.content?.trim() || DEFAULT_RECORDS_SUMMARY.content,
});

const buildCategoriesFromPlan = (plan) => {
    const subsections = plan?.futureCareNeeds?.subsections || [];
    return subsections
        .filter((subsection) => subsection?.title?.trim())
        .map((subsection) => ({
            name: subsection.title.trim(),
            severity: 'review',
            description: subsection?.content?.trim() || '',
        }));
};

const usePreliminaryPreviewModel = ({ plaintiffName, dateOfLoss, recordsReviewed, plan, hasEstimate, formattedIncrease }) => {
    return useMemo(() => {
        const planCategories = buildCategoriesFromPlan(plan);
        const categories = planCategories.length > 0 ? planCategories : FALLBACK_CARE_CATEGORIES;

        return {
            identity: {
                matter: plaintiffName,
                dateOfLoss: dateOfLoss || 'Not on file',
                recordsReviewed: recordsReviewed || DEFAULT_RECORDS_REVIEWED,
                recommendedAction: RECOMMENDED_ACTION,
            },
            estimate: { hasEstimate, formattedIncrease },
            signal: hasEstimate? FUTURE_CARE_SIGNAL.medium : FUTURE_CARE_SIGNAL.low,
            recordsSummary: buildRecordsSummaryFromPlan(plan),
            categories,
            nextStep: ATTORNEY_NEXT_STEP,
            plan,
            routes: RECOMMENDED_ROUTES,
            disclaimer: PREVIEW_DISCLAIMER,
        };
    }, [plaintiffName, dateOfLoss, recordsReviewed, plan, hasEstimate, formattedIncrease]);
};

export default usePreliminaryPreviewModel;
